import React from "react";
import Chip from "@material-ui/core/Chip";
import Tooltip from "@material-ui/core/Tooltip";

const PaymentStatusBadge = ({ has_problems }) => {
  return (
    <Tooltip
      title={has_problems ? "Problemas de pagamento" : "Pagamentos em dia"}
    >
      <Chip
        className={
          has_problems
            ? "payments-badge-avatar payments-badge-avatar-error"
            : "payments-badge-avatar payments-badge-avatar-ok"
        }
        label={" € "}
      ></Chip>
    </Tooltip>
  );
};

export default PaymentStatusBadge;
